import { CategoryCardsUI } from './CategoryCardsUI'
import { CategoryCardsLegacyUI } from './CategoryCardsUI.legacy'
import { useCategoryCards } from './useCategoryCards'
import { useCategoryCardsLegacy } from './useCategoryCards.legacy'
import type { ICategoryCard } from './types'

interface CategoryCardsProps {
  className?: string
}

const isGeneticTestEnabled = import.meta.env.VITE_APP_GENETIC_TEST_ENABLED === 'true'

const CategoryCardsNew = ({ className }: CategoryCardsProps) => {
  const { categories, handleCategoryClick, isSelectedCategory } = useCategoryCards()

  return (
    <CategoryCardsUI
      categories={categories}
      onCategoryClick={handleCategoryClick}
      isSelectedCategory={isSelectedCategory}
      className={className}
    />
  )
}

const CategoryCardsLegacy = ({ className }: CategoryCardsProps) => {
  const { categories, handleCategoryClick, isSelectedCategory, handleViewAll } = useCategoryCardsLegacy()

  return (
    <CategoryCardsLegacyUI
      categories={categories}
      onCategoryClick={handleCategoryClick}
      isSelectedCategory={isSelectedCategory}
      onViewAll={handleViewAll}
      className={className}
    />
  )
}

export const CategoryCards = ({ className }: CategoryCardsProps) => {
  if (isGeneticTestEnabled) return <CategoryCardsNew className={className} />
  return <CategoryCardsLegacy className={className} />
}

export type { ICategoryCard }
